export const questionInputLayoutTypes = {
    DefaultInputType: 0,
	Button: 6,
	CircularSlider: 9,
    HorizontalSlider: 10
}